/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentUpgradeStatusEnum } from './deploymentUpgradeStatusEnum';


export interface UpgradeStatusInfo { 
    /**
     * Deployment Id of entity passed in request body to check for validations.
     */
    deployment_id: string;
    /**
     * Org Id of entity passed in request body to check for validations.
     */
    org_id: string;
    upgrade_status: DeploymentUpgradeStatusEnum;
}
export namespace UpgradeStatusInfo {
}


